<div class="dialog-header">
  <span mat-dialog-title>
    @if (data?.tenantImage) {
      <img
        class="tenant-image"
        [src]="transform(data?.tenantImage)"
        [alt]="'accessibility_alt_tenant_img' | translate"
      />
    }
  </span>
</div>
@if (terms) {
  <div mat-dialog-content class="dialog-with-bottom-buttons terms-content">
    <div class="terms-title" [innerHTML]="terms.termsConditionsTitle"></div>
    <div class="terms-title" [innerHTML]="terms.termsConditionsSubtitle"></div>
    <div class="terms-fullname">{{ 'label_dear' | translate }} {{ authUser.fullname }}</div>
    <div class="terms-conditions" [innerHTML]="terms.termsConditions"></div>
    <div class="terms-button">
      <button (click)="deny()" mat-button color="warn">
        {{ 'label_decline_logout' | translate }}
      </button>
      <div class="terms-hereby">
        <mat-checkbox [(ngModel)]="hereByChecked">{{ terms.termsConditionsHereby }}</mat-checkbox>
      </div>
      <button (click)="agree()" mat-flat-button color="primary" [disabled]="!hereByChecked">
        {{ 'label_submit' | translate }}
      </button>
    </div>
    @if (quoteText && quoteAuthor) {
      <div class="sidemenu-quote-container">
        <span class="quote">"{{ quoteText }}"</span>
        <mat-divider></mat-divider>
        <span class="author">{{ quoteAuthor }}</span>
      </div>
    }
  </div>
}
